import { imageMap } from '../config/imageMap';

/**
 * Return the localized image URL for a given imageKey + language.
 * Fallback behaviour (Decision 6): if the FR file is null, return the EN
 * file — no auto-translation, no substitution, just a temporary fallback
 * until the client-supplied FR version lands.
 */
export const getLocalizedImage = (imageKey, language = 'en') => {
  const entry = imageMap[imageKey];
  if (!entry) return '';
  if (language === 'fr' && entry.fr) return entry.fr;
  return entry.en;
};

/**
 * Return the localized `alt` text for a given imageKey + language.
 */
export const getLocalizedAlt = (imageKey, language = 'en') => {
  const entry = imageMap[imageKey];
  if (!entry) return '';
  return language === 'fr' ? (entry.altFr || entry.altEn) : entry.altEn;
};

export default getLocalizedImage;
